var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.72222C11.4194 5.72222 10.9225 5.51551 10.509 5.10208C10.0956 4.68866 9.88889 4.19167 9.88889 3.61111C9.88889 3.03056 10.0956 2.53356 10.509 2.12014C10.9225 1.70671 11.4194 1.5 12 1.5C12.5806 1.5 13.0775 1.70671 13.491 2.12014C13.9044 2.53356 14.1111 3.03056 14.1111 3.61111C14.1111 4.19167 13.9044 4.68866 13.491 5.10208C13.0775 5.51551 12.5806 5.72222 12 5.72222ZM8.83333 22.6111V8.88889C7.77778 8.80093 6.70463 8.66898 5.61389 8.49306C4.52315 8.31713 3.48519 8.09722 2.5 7.83333L3.02778 5.72222C4.4 6.09167 5.86019 6.35995 7.40833 6.52708C8.95648 6.69421 10.487 6.77778 12 6.77778C13.513 6.77778 15.0435 6.69421 16.5917 6.52708C18.1398 6.35995 19.6 6.09167 20.9722 5.72222L21.5 7.83333C20.5148 8.09722 19.4769 8.31713 18.3861 8.49306C17.2954 8.66898 16.2222 8.80093 15.1667 8.88889V22.6111H13.0556V16.2778H10.9444V22.6111H8.83333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModel);
export default __webpack_public_path__ + "static/media/icon-model.47933c7cb1d58c20b713d68052e73b5a.svg";
export { ForwardRef as ReactComponent };